export const privilegeTypes = ['create', 'update', 'delete', 'view_list', 'view_detail'];

export type PrivilegeEntry = {
    id: string,
    value: boolean,
    method: string,
};

export type PrivilegeChild = {
    [key: string]: PrivilegeEntry | string | null,
    // name & description are string, the rest are PrivilegeEntry | null
};

export type Privilege = {
    id: string,
    name: string,
    description: string,
    is_parent: boolean,
    parent_id: string,
    children: PrivilegeChild[],
};

export const listInitialPrivileges = (privileges: Privilege[]) => {
    const allowed: string[] = [];
    const denied: string[] = []; // this does NOT include null

    privileges.map((privilege) => {
        privilege.children.map((privilegeChild) => {
            privilegeTypes.map((privilegeType) => {
                const entry = privilegeChild[privilegeType];
                if (typeof(entry) === 'object' && entry != null){
                    if (entry.value){
                        allowed.push(entry.id);
                    } else {
                        denied.push(entry.id);
                    }
                }
            });
        });
    });

    return { allowed, denied };
};

const arrayIntersection = <T>(array1: T[], array2: T[]): T[] => (
    array1.filter((entry) => array2.includes(entry))
);

export const getRevokedPrivileges = (currentlyDenied: string[], initiallyAllowed: string[]): string[] => (
    arrayIntersection(currentlyDenied, initiallyAllowed)
);

export const getAssignedPrivileges = (currentlyAllowed: string[], initiallyDenied: string[]): string[] => (
    arrayIntersection(currentlyAllowed, initiallyDenied)
);
